
  import { css } from 'lit';
  export const styles = css`[part~=sent]{border-radius:.5rem}`;
  